import { styled } from "styled-components";

export const Wrapper = styled.section`
  h4 {
    color: #1b1b1b;
  }
  .skills-category-container {
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    flex-wrap: wrap;
  }
  p {
    color: white;
  }
  @media screen and (max-width: 700px) {
    h4 {
      text-align: center;
    }
    .skills-category-container {
      gap: 0.5rem;
      justify-content: center;
    }
  }
`;
